<!--
Author: Lsc
Date: 2019-08-20
Desc: 我的预约，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-my-order bizcomp ' + className">
        <comp-title :title="title" />
        <el-table :data="ofund" style="width: 100%" class="tab-list-tit">
            <el-table-column label="基金名称" width="320" class-name="fund-offset">
                <template slot-scope="scope">
                    <span v-html="getFundName(scope.row)" />
                </template>
            </el-table-column>
            <el-table-column prop="serialno" label="预约协议号" width="250" align="center" />
            <el-table-column label="预约金额" align="center">
                <template slot-scope="scope">
                    <div v-html="$util.fmtNum(scope.row.applicationamount)" />
                </template>
            </el-table-column>
            <el-table-column label="预约份额" align="center">
                <template slot-scope="scope">
                    <div v-html="$util.fmtNum(scope.row.applicationvol)" />
                </template>
            </el-table-column>
            <el-table-column
                prop="systemdate"
                width="110"
                label="申请日期"
                align="center"
                :formatter="formatterDate"
            />
            <el-table-column prop="systemtime" width="110" label="下单时间" align="center" />
            <el-table-column label="业务名称" align="center">
                <template slot-scope="scope">
                    <div v-html="$cache.getDict('130010', scope.row.businesscode)" />
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" :width="100">
                <template slot-scope="scope">
                    <el-tooltip
                        v-if="scope.row.status !== '0'"
                        class="item"
                        effect="info"
                        content="协议已终止"
                        placement="left"
                    >
                        <el-button type="lock" size="small">终止</el-button>
                    </el-tooltip>
                    <el-button
                        v-else
                        type="yellow"
                        plain
                        size="small"
                        v-on:click.stop="stopOrder(scope.row)"
                    >
                        终止
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
    name: "MyOrder",
    mixins: [mixin],
    data() {
        return {
            ofund: []
        };
    },
    created() {
        this.getFundLists();
    },
    methods: {
        stopOrder(data) {
            const _this = this;
            this.$confirm("您是否确认终止该预约协议？", "预约协议终止", {
                confirmButtonText: "终止",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                _this.$util
                    .request("booking/sell/stop", { serialno: data.serialno }, "POST")
                    .then((res) => {
                        if (res.data) {
                            _this.$message({
                                type: "success",
                                message: "终止预约协议成功"
                            });
                            _this.getFundLists();
                        }
                    });
            });
        },
        formatterDate(row, column, value) {
            return this.$util.fmtDate(value);
        },
        // 获取基金名称显示
        getFundName(val) {
            return val.fundname + "(" + val.fundcode + ")";
        },
        // 获取资产信息
        getFundLists() {
            const _this = this;
            this.$util.request("booking/sell/funds", {}, "GET").then((res) => {
                if (res.data) {
                    _this.ofund = res.data;
                }
            });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-my-order {
    .wisdom-icon {
        font-size: $f12;
        display: inline-block;
        font-style: normal;
        background-color: $color-c;
        color: $text-color6;
        width: 18px;
        height: 18px;
        line-height: 18px;
        vertical-align: middle;
        text-align: center;
        border-radius: 50%;
        margin-right: 4px;
    }
    .el-tabs__header {
        margin: 0;
    }
    .el-tabs__nav-wrap:after {
        background: $border-color3;
        height: 1px;
    }
    .el-tabs__nav-scroll {
        line-height: 50px;
        padding: 0 20px;
        .el-tabs__active-bar {
            background: $color-a;
        }
        .el-tabs__item {
            font-size: $f18;
            &.is-active {
                color: $color-a;
            }
            .el-badge__content.is-fixed {
                top: 10px;
                right: 1px;
            }
        }
    }
    .el-tabs__content {
        padding: 0 0 20px;
        .fund-offset .cell {
            padding: 0 10px 0 20px;
        }
        .fund-arr {
            padding: 0 20px;
            .cell {
                padding: 0;
            }
        }
    }
}
</style>
